<template>
  <div style="display:flex; flex-direction:column; padding:10px">
    <DateSelection
      :selectedDateFilter="widget.dateFilter || {}"
      @updateDateFilter="updateDateFilter"
    />
    <div>
      <div style="font-weight:600;">
        {{ $t('siteDashboard.serviceCall.title') }}
      </div>
      <div v-if="isRange">
        {{ range }}
      </div>
    </div>

    <table>
      <thead>
        <tr>
          <th>{{ $t('siteDashboard.serviceCall.workOrderType') }}</th>
          <th>{{ $t('siteDashboard.serviceCall.numberOfWorkorders') }}</th>
          <th>{{ $t('siteDashboard.serviceCall.averageTimeWorked') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(call, index) in serviceCalls"
          :key="index"
        >
          <td>{{ call.workOrderType.name[userLang] }}</td>
          <td>
            {{ call.woNumbers }}
          </td>
          <td>{{ formattedTime(Math.round(Number.parseFloat(call.averageSpendTime).toFixed(2))) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import { cloneDeep, isEqual } from 'lodash';
import DateSelection from './DateSelection.vue';

export default {
    components: {
        DateSelection,
    },
    props: {
        widget: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            serviceCalls: [],
        };
    },
    computed: {
        ...mapGetters(['site', 'userLang']),
        isRange() {
            return !!(this.widget?.dateFilter?.range && this.widget?.dateFilter?.range.length);
        },
        range() {
            const [from, to] = this?.widget?.dateFilter?.range;
            const [fromDate] = from.split('T');
            const [toDate] = to.split('T');
            return `${this.$t('siteDashboard.serviceCall.from')} ${fromDate} ${this.$t('siteDashboard.serviceCall.to')} ${toDate}`;
        },
    },
    watch: {
        'widget.dateFilter': {
            handler(oldValue, newValue) {
                if (!isEqual(oldValue, newValue)) this.getServiceCalls();
            },
            immediate: true,
            deep: true,
        },
    },
    created() {
        this.getServiceCalls();
    },
    methods: {
        async getServiceCalls() {
            this.serviceCalls = await this.$rq.getSiteServiceCallStatistics(this.site.id, { dateFilter: this.widget.dateFilter });
        },
        updateDateFilter({ isRange, value }) {
            const dateFilter = {
                relativeRange: isRange ? null : value,
                range: isRange ? value : [],
            };
            const cloneWidget = cloneDeep(this.widget);
            cloneWidget.dateFilter = dateFilter;
            this.$emit('updateWidgetInLayout', cloneWidget);
        },
        formattedTime(averageTimeSpent) {
            if (!averageTimeSpent) return 0;
            const h = Math.floor(averageTimeSpent / 60);
            const m = averageTimeSpent % 60;
            return `${h}:${m.toString().padStart(2, '0')}`;
        },
    },
};
</script>
<style scoped>

table{
    padding: 50px;
}
th{
    padding: 10px;
    text-align: start;
}
thead tr{
  border-bottom: 1px solid black;
}
td{
  padding: 10px;
}
</style>
